module.exports = __webpack_public_path__ + "static/media/profile-icon.f4dd027e.svg";